import { MessageDescriptor } from './types';

export type KeyedDescriptors = {
  [key: string]: MessageDescriptor;
};

const labels: KeyedDescriptors = {
  abbSlash: {
    id: 'pages.patientViewer.table.selectOptions.abbSlash',
    defaultMessage: '4/17/2012',
  },
  abbHyphen: {
    id: 'pages.patientViewer.table.selectOptions.abbHyphen',
    defaultMessage: '4-17-2012',
  },
  yearRev: {
    id: 'pages.patientViewer.table.selectOptions.yearRev',
    defaultMessage: '2012-04-17',
  },
  fullMonth: {
    id: 'pages.patientViewer.table.selectOptions.fullMonth',
    defaultMessage: 'April 4, 2012',
  },
  abbMonth: {
    id: 'pages.patientViewer.table.selectOptions.abbMonth',
    defaultMessage: ' Apr 4, 2012',
  },
  abbSlashTime: {
    id: 'pages.patientViewer.table.selectOptions.abbSlashTime',
    defaultMessage: '4/17/2012 11:59 PM',
  },
  abbHyphenTime: {
    id: 'pages.patientViewer.table.selectOptions.abbHyphenTime',
    defaultMessage: '4-17-2012 11:59 PM',
  },
  yearRevTime: {
    id: 'pages.patientViewer.table.selectOptions.yearRevTime',
    defaultMessage: '2012-04-17 11:59 PM',
  },
  fullMonthTime: {
    id: 'pages.patientViewer.table.selectOptions.fullMonthTime',
    defaultMessage: 'April 4, 2012 11:59 PM',
  },
  abbMonthTime: {
    id: 'pages.patientViewer.table.selectOptions.abbMonthTime',
    defaultMessage: ' Apr 4, 2012 11:59 PM',
  },
};

export type ConfiguredMomentFormat =
  | 'M/D/YYYY'
  | 'M-D-YYYY'
  | 'YYYY-MM-DD'
  | 'MMMM D, YYYY'
  | 'MMM D, YYYY'
  | 'D/M/YYYY h:mm A'
  | 'D-M-YYYY h:mm A'
  | 'YYYY-MM-DD h:mm A'
  | 'MMMM D, YYYY h:mm A'
  | 'MMM D, YYYY h:mm A';

export type MomentFormatDipslayConfig = {
  value: ConfiguredMomentFormat;
  intlDisplay: MessageDescriptor;
};

const formats: MomentFormatDipslayConfig[] = [
  {
    value: 'M/D/YYYY',
    intlDisplay: labels.abbSlash,
  },
  {
    value: 'M-D-YYYY',
    intlDisplay: labels.abbHyphen,
  },
  {
    value: 'YYYY-MM-DD',
    intlDisplay: labels.yearRev,
  },
  {
    value: 'MMMM D, YYYY',
    intlDisplay: labels.fullMonth,
  },
  {
    value: 'MMM D, YYYY',
    intlDisplay: labels.abbMonth,
  },
  {
    value: 'D/M/YYYY h:mm A',
    intlDisplay: labels.abbSlashTime,
  },
  {
    value: 'D-M-YYYY h:mm A',
    intlDisplay: labels.abbHyphenTime,
  },
  {
    value: 'YYYY-MM-DD h:mm A',
    intlDisplay: labels.yearRevTime,
  },
  {
    value: 'MMMM D, YYYY h:mm A',
    intlDisplay: labels.fullMonthTime,
  },
  {
    value: 'MMM D, YYYY h:mm A',
    intlDisplay: labels.abbMonthTime,
  },
];

export default formats;

export const defaultMomentFormat = formats[0].value;

/**
 * Validates configured value is still selectable.
 * If no value configured, retrieves default value
 * @param {*} configValue
 */
export function validateMomentFormat(
  configValue?: ConfiguredMomentFormat,
): ConfiguredMomentFormat {
  if (!configValue) return defaultMomentFormat;

  const configuredFormat = formats.find(format => format.value === configValue);

  return configuredFormat ? configuredFormat.value : defaultMomentFormat;
}
